/**
 * Admin Conversation Monitoring Page
 * Dedicated page for monitoring platform conversations
 */

import React from 'react';
import {
  Container,
  Box,
  Typography,
  Breadcrumbs,
  Link
} from '@mui/material';
import { NavigateNext, Chat } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ConversationMonitoringDashboard from '../components/admin/ConversationMonitoringDashboard';

const AdminConversationsPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs 
        separator={<NavigateNext fontSize="small" />} 
        sx={{ mb: 2 }}
      >
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          color="inherit"
          onClick={() => navigate('/admin')}
        >
          Admin Dashboard
        </Link>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
          <Chat sx={{ mr: 0.5 }} fontSize="inherit" />
          Conversation Monitoring
        </Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Conversation Monitoring Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Real-time monitoring of platform conversations and security alerts
        </Typography>
      </Box>

      {/* Dashboard */}
      <ConversationMonitoringDashboard />
    </Container>
  );
};

export default AdminConversationsPage;



